import axios from 'axios';
import store from '@/core/store';
import router from '@/core/router';

/**
 * @description Replace request token
 * @param request
 * @returns {*}
 */
const replaceRequestToken = (request) => {
  const { headers } = request;
  const nextToken = store.getters['auth/token'];

  if (nextToken) {
    headers.Authorization = `Bearer ${nextToken}`;
  }

  return {
    ...request,
    headers
  };
};

/**
 * @description Request interceptor
 * @param config
 * @returns {*}
 */
const requestInterceptor = (config) => {
  const augmentedConfig = { ...config };
  const nextConfig = replaceRequestToken(augmentedConfig);

  return nextConfig;
};

/**
 * @description Response interceptor
 */
const responseInterceptor = (response) => response;

const responseErrorInterceptor = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      store.dispatch('auth/logout');
      router.push({ name: 'login' });
    }
  }
  return Promise.reject(error);
};

// Register interceptors
axios.interceptors.request.use(requestInterceptor);
axios.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

export default axios;
